import '.a{display:flex;}.ssr-plugin'
import '.ax{gap:16px;}.ssr-plugin'
import '.ac{flex-direction:column;}.ssr-plugin'
import '.j5{margin:96px 0px;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { Text } from '../Text/index.js'
import { Separator } from '../Separator/index.js'
import { Badge } from '../Badge/index.js'
import { prettyDate } from '@based/pretty-date'
import { truncateString } from '../../utils/truncateString.js'
import { parseValueFromSchema } from '../../utils/parseValueFromSchema.js'
import { capitalize } from '../../utils/text.js'
import { useUser } from '../../hooks/useUser.js'

export type HeaderProps = {
  initialData?: {
    id?: string
    name?: string
    updatedAt?: number
    createdAt?: number
    [key: string]: any
  }
  customTitle?: string
  schemaType?: string
  style?: Style
  variant?: 'full' | 'mini'
}

export const Header = ({
  initialData,
  customTitle,
  schemaType,
  style,
  variant = 'full',
}: HeaderProps) => {
  const me = useUser()

  const parsedTitle =
    customTitle || parseValueFromSchema(initialData, schemaType)
  const createdOrUpdated = initialData?.updatedAt || initialData?.createdAt
  const isMe = initialData?.createdBy && initialData?.createdBy?.id === me?.id
  const parsedCreatedBy =
    initialData?.createdBy && isMe
      ? 'by you'
      : initialData?.createdBy
        ? `by ${capitalize(initialData?.createdBy?.name)}`
        : ''

  return (
    <styled.div className="a ax ac j5"
      style={{
        ...style,
      }}
    >
      <Text variant="title-medium" singleLine>
        {truncateString(parsedTitle?.toString() || 'untitled', 56)}
      </Text>
      {variant === 'full' && (
        <div className="a">
          {initialData?.id && (
            <>
              <Badge color="neutral-subtle">{'# ' + initialData?.id}</Badge>
              <Separator variant="dot" />{' '}
              <Text
                variant="display-regular"
                color="neutral60"
                style={{ textTransform: 'capitalize', marginTop: 2 }}
              >
                {schemaType}{' '}
              </Text>
            </>
          )}
          {createdOrUpdated !== undefined &&
            createdOrUpdated !== null &&
            createdOrUpdated !== 0 && (
              <>
                <Separator variant="dot" />{' '}
                <Text
                  variant="display-regular"
                  color="neutral60"
                  style={{ marginTop: 2 }}
                >
                  Last saved{' '}
                  {String(
                    prettyDate(createdOrUpdated, 'date-time-human'),
                  ).toLowerCase()}{' '}
                  {parsedCreatedBy}
                </Text>
              </>
            )}
        </div>
      )}
    </styled.div>
  )
}
